import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../../data/modules';
import { CheckoutButton } from '../CheckoutButton';
export function ModulesSection() {
  return <section className="bg-sand-50 px-4 py-14 sm:py-20" data-id="element-229" data-mp="2os2v29a36rhr">
      <div className="mx-auto w-full max-w-5xl" data-id="element-230" data-mp="2osmbflk397to">
        <div className="text-center" data-id="element-231" data-mp="2trfq3hb434vf">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-232" data-mp="2tqe4wk0dt1zz">
            📦 What's inside
          </p>
          <h2 className="mt-3 font-display text-[28px] font-bold leading-[1.12] tracking-tight text-navy-900 sm:text-4xl" data-id="element-233" data-mp="2128i7rprp2xi">
            The 10 core modules of PROSTHO 360™
          </h2>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-234" data-mp="2as1ukuxqhm2t">
          {modules.map(mod => <article key={mod.number} className="flex flex-col rounded-2xl bg-white p-5 shadow-card ring-1 ring-navy-800/8 sm:p-6" data-id="element-235" data-mp="2atuyw3kvju7n">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-aqua-500" data-id="element-236" data-mp="1i9wjdeybojs4">
                {mod.number}
              </p>
              <h3 className="mt-2 font-display text-[21px] font-bold leading-tight text-navy-900 sm:text-2xl" data-id="element-237" data-mp="19pvd7qqvcabn">
                {mod.title}
              </h3>
              <p className="mt-2.5 text-[14.5px] leading-relaxed text-navy-800/70" data-id="element-238" data-mp="14xkdanw4ooj3">{mod.intro}</p>

              <p className="mt-4 text-[11.5px] font-bold uppercase tracking-wide text-navy-800/45" data-id="element-239" data-mp="10vz53fujgyf8">
                {mod.listLabel}
              </p>
              <ul className="mt-2 space-y-1.5" data-id="element-240" data-mp="qzmcklaqcqm2">
                {mod.items.map(item => <li key={item} className="flex gap-2" data-id="element-241" data-mp="m09fl7q5a35r">
                    <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-aqua-500" aria-hidden="true" data-id="element-242" data-mp="m2vmr694igng" />
                    <span className="text-[14px] leading-snug text-navy-800/80" data-id="element-243" data-mp="i1k6hrc537rx">{item}</span>
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-9" data-id="element-244" data-mp="2cbe1ahexbm9a">
          <CheckoutButton label="I want all 10 modules" sub="Instant access · $27 one-time payment" data-id="element-245" data-mp="9q1m03tj4m86" />
        </div>
      </div>
    </section>;
}